// extracted by mini-css-extract-plugin
export default {"icon":"CustomIcon_icon__wOHCd","notification":"CustomIcon_notification__UFw46"};